/**
 * ObligationEngineView (P143 -> P144) -- the framework obligation Engine
 * console. Now a thin wrapper over the shared EngineBatchRunsPanel; the
 * substrate (run/poll/progress) is generic.
 */
import { EngineBatchRunsPanel } from "shared/admin/EngineBatchRunsPanel";
import { useTranslation } from "react-i18next";

const KINDS = [
  {
    kind: "summarise",
    name: "Summarise obligations",
    desc: "Roll each obligation's implementing controls into a concise requirement statement (engine_summary). Sharpens dedup, tagging, and the obligations panel.",
  },
  {
    kind: "tag_applicability",
    name: "Tag applicability",
    desc: "Tag each obligation's outcome-category / classification / sovereign-only so the twin deriver narrows per-entity sets. Run after summarise; re-derive obligations afterwards.",
  },
];

const _BASE = "/v1/admin/framework/obligations";

export function ObligationEngineView() {
  const { t } = useTranslation();
  return (
    <EngineBatchRunsPanel
      testid="obligation-engine-view"
      rubric="Admin · Marsad Engine"
      heading={t("screens.obligationEngineView.obligationEnginePasses")}
      intro="Run the catalogue-wide Engine passes and watch them complete in app. Each runs in the background — safe to navigate away and come back."
      notAdminMessage="The obligation Engine console is admin-only."
      kinds={KINDS}
      listPath={`${_BASE}/engine-runs`}
      triggerPath={(kind) =>
        kind === "summarise" ? `${_BASE}/summarise` : `${_BASE}/tag-applicability`
      }
    />
  );
}
